import MeridianSearchField from '@amzn/meridian/search-field';
import { withTestId } from '../../../utils/testId';
import { localizeWithRef } from './localize';

const SearchField = withTestId(
    localizeWithRef(MeridianSearchField, ['clearButtonLabel', 'label', 'placeholder', 'searchButtonLabel'])
);

export default SearchField;
